import { StorageKey } from "@/util";
import AppStorage from "@/util/services/storage";
import { Email } from "@/util/types/consultation";
import { createSlice } from "@reduxjs/toolkit";

const initialState: Partial<Email> = AppStorage.getItem(StorageKey.Email) || {};

export const email=createSlice({
    name:'Email',
    initialState,
    reducers:{
          REMOVE_EMAILCOMPOSE:()=>{
          AppStorage.deleteItem(StorageKey.Email);
           return{}
          },
          ADD_EMAILCOMPOSE:(state,action)=>{
                 AppStorage.saveItem(StorageKey.Email,action.payload)
                  return {...state,...action.payload};
          }
    }
})

export const{REMOVE_EMAILCOMPOSE,ADD_EMAILCOMPOSE}=email.actions;
export default email.reducer;